import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DozentTeamMember {
  id: string;
  name: string;
  email: string;
  role: string;
}

/**
 * Holds the currently selected dozent filter for the dozent area.
 * `null` means "all dozents" (only meaningful for admin/manager users —
 * the backend forces regular dozents to their own user_id regardless).
 */
@Injectable({ providedIn: 'root' })
export class DozentFilterService {
  private readonly tutorsBase = environment.tutorsBackend;

  selectedDozentUserId$ = new BehaviorSubject<string | null>(null);
  team$ = new BehaviorSubject<DozentTeamMember[]>([]);
  isAdminView$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  loadTeam() {
    return this.http.get(`${this.tutorsBase}/dozent/team`).pipe(
      map((d: any) => {
        this.team$.next(d.data ?? []);
        this.isAdminView$.next(!!d.is_admin_view);
        return d;
      })
    );
  }

  setSelected(userId: string | null) {
    this.selectedDozentUserId$.next(userId);
  }

  get selected(): string | null {
    return this.selectedDozentUserId$.value;
  }
}
